/**
 * @generated SignedSource<<6ef8e24866c7bd7736898a3a908c66a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_viewer">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_viewer";
};
export type PdpSharedCondensedSidebarButtons_viewer$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "85dd45fb4919be55310504fb7d0fde3f";

export default node;
